
import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    id: 1,
    icon: "fas fa-truck",
    title: "Nosotros llevamos la cabina 360° a tu evento",
    description: "Nos encargamos de todo el montaje y configuración. Tú solo preocúpate por disfrutar."
  },
  {
    id: 2,
    icon: "fas fa-magic",
    title: "Personalizamos la experiencia y guiamos a tus invitados",
    description: "Nuestro staff profesional se encarga de que todos se diviertan y capturen momentos únicos."
  },
  {
    id: 3,
    icon: "fas fa-qrcode",
    title: "Entregamos los videos en minutos vía QR",
    description: "¡Sin esperas! Tus invitados reciben sus videos al instante para compartir en redes sociales."
  },
  {
    id: 4,
    icon: "fas fa-cloud-download-alt",
    title: "Tus recuerdos quedan disponibles por 30 días",
    description: "Tiempo suficiente para descargar, compartir y revivir esos momentos especiales."
  }
];

function HowItWorks() {
  return (
    <section className="how-it-works section">
      <div className="container">
        <h2>¿Cómo funciona?</h2>
        <p className="subtitle">¡Nosotros nos encargamos de todo para que tú solo disfrutes!</p>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={step.id} className="step-card card">
              <div className="step-number">{step.id}</div>
              <div className="step-icon">
                <i className={step.icon}></i>
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
